// function for setting cell color based on percentage //
import { Link } from "gatsby"
import React from "react"
import tinycolor from 'tinycolor2'

import confStyles from './conf_bar_new.module.scss'

const ConfRank = ({ season, week, homeTeam, awayTeam, rank }) => {
    
    const q4b = '#c9dcff'
    const q3b = '#e0d1ff'
    const q2b = '#ffd1fd'
    const q1b = '#ffd1dd'
    const q1t = '#fff9d1'


    // background //
    var calcedBackground = '#ffffff'

    if (rank <= 4) {
        calcedBackground = tinycolor.mix(q4b, q3b, 100 * (rank - 1) / 3 )
    } else if (rank <= 8) {
        calcedBackground = tinycolor.mix(q3b, q2b, 100 * (rank - 5) / 3 )
    } else if (rank <= 12) {
        calcedBackground = tinycolor.mix(q2b, q1b, 100 * (rank - 9) / 3 )
    } else {
        calcedBackground = tinycolor.mix(q1b, q1t, 100 * (rank - 13) / 3 )
    }


    return (

        <td className={confStyles.confidenceTd}>
            <Link
                className={confStyles.gameLink}
                to={`/games/${season}-week-${week}-${awayTeam.toLowerCase()}-at-${homeTeam.toLowerCase()}-betting-preview/`}
            >
                <div className={confStyles.rankContainer}>
                    <div className={confStyles.rankBall} style={{backgroundColor : calcedBackground}}></div>
                    <div className={confStyles.rankNum}>
                        {rank}
                    </div>
                </div>
            </Link>
        </td>

    )
    
}

export default ConfRank